module.exports = __webpack_public_path__ + "static/media/3DPPA43.c9b449a2.jpg";